import {createSlice} from '@reduxjs/toolkit'


const interfaceInitialState = {
    phase: 'ready',
    blocksCount: 10,
    startTime: 0,
    endTime: 0,
    blocksSeed: 0
}

const interfaceSlice = createSlice({
    name: 'interface',
    initialState: interfaceInitialState,
    reducers:{
        onStart:(state)=>{
            if(state.phase === 'ready'){
                state.phase = 'playing'
                state.startTime = Date.now()
            }
        },
        onRestart:(state)=>{
            if(state.phase === 'playing' || state.phase === 'ended'){
                state.phase = 'ready'
                state.blocksSeed = Math.random()
                // console.log('From Redux Store ===', state.phase)
            }
        },
        onEnd:(state)=>{
            if(state.phase === 'playing'){
                state.phase = 'ended'
                state.endTime = Date.now()
            }
        }
    }
})

export default interfaceSlice